/* eslint eqeqeq: "off" */
import * as React from 'react';
import { connect } from 'react-redux';
import { navigateTo } from '../../../actions/navigationActions';
import { setSalesReducer } from '../../../actions/salesActions';
import { ProgressBar, Button, Dropdown, Form } from 'react-bootstrap';
import './Bling.css';
import { REGULAR_CELLPHONE_REGISTRATION_NUMBER, REGULAR_DRIVER } from '../../../routes/routes';
import { SET_QUOTE_DATA } from '../../../constants/constants';
import { isMobile} from 'react-device-detect';

class CellphoneCase extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);
        this.state = {
            loggedIn: this.props.auth.uid ? true : false,
            protectiveCase: "",
        };
        this.handleSelection = this.handleSelection.bind(this);
        this.handleBack = this.handleBack.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    async handleSelection(e) {
        await this.setState({protectiveCase : e.target.value})
    }

    handleBack() {
        this.props.dispatchAction(navigateTo(REGULAR_CELLPHONE_REGISTRATION_NUMBER))
    }

    handleSubmit() {
        var caseEnum = this.state.protectiveCase == "yes" ? 1 : 0;
        this.props.dispatchAction(setSalesReducer(SET_QUOTE_DATA, "protectiveCase", caseEnum))
        this.props.dispatchAction(navigateTo(REGULAR_DRIVER))
    }

    public render() {
        return (
            <div className={isMobile ? "pt-lg-5 p-lg-0 pt-1px" : "pt-lg-5 p-lg-0 logged-in ml-0px"}>
                <div className="col-12 text-lg-center text-md-center">
                    <div className="container ssp-add-portable-possessions-replacement-value">
                        <div className="row justify-content-center mobile-mt-60px">
                            <div className="col-lg-12 col-md-12">
                                <div className="row justify-content-center">
                                    <div className="col-2 col-md-3 col-lg-3 col-xl-2 pt-lg-2 text-center align-self-center">
                                        <div className="BackRectangle d-none d-lg-block d-md-block">
                                            <button onClick={this.handleBack} className="Back cursor-pointer"><img src="./images/OnlineQuotation/icon-back-button-desktop.png" alt="" /></button>
                                        </div>
                                        <div className="sidenav d-lg-none d-md-none" id="mySidenav">
                                            <button onClick={this.handleBack} className="Back cursor-pointer" id="about"><img src="./images/OnlineQuotation/icons-navigation-quote-back-btn.png" alt="" /></button>
                                        </div>
                                    </div>
                                    <div className="col-10 col-md-9 col-lg-9 col-xl-10 p-0 text-center align-self-center">
                                        <div>
                                            <ProgressBar variant="success" now={45} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="container mt-32px mobile-mt-20px">
                        <div className="row justify-content-center">
                            <div className="col-lg-12 col-md-12 nopa">
                                <div className="row noma">
                                    <div className="col nopa"></div>
                                    <div className="col-lg-10 nopa">
                                        <div className="ssp-addportable-possessions-crown-icon mt-0px text-center">
                                            <div className="ssp-sales-journey-crown-icon" title="Add portable possessions"></div>
                                        </div>
                                        <div className="ma-top-21px text-center">
                                    <p className="text-16 font-weight-500">Does your cellphone have a protective case on it 24/7</p>
                                </div>
                                <div className="mt-30px mb-40px">
                                    <div className="row d-flex justify-content-center">
                                        <div className="col-md-2 col-6 pl-0px">
                                            <button className={this.state.protectiveCase == 'yes' ? 'btn btn-block btn-solid-red font-weight-bold w-100' : 'btn btn-block btn-outline-red font-weight-bold w-100'} type="button" id="btnYes" value="yes" onClick={this.handleSelection}>Yes</button>
                                        </div>
                                        <div className="col-md-2 col-6 pr-0px">
                                            <button className={this.state.protectiveCase == 'no' ? 'btn btn-block btn-solid-red font-weight-bold w-100' : 'btn btn-block btn-outline-red font-weight-bold w-100'} type="button" id="btnNo" value="no" onClick={this.handleSelection}>No</button>
                                        </div>
                                    </div>
                                </div>
                                <div className="row justify-content-center">
                                    <div className="col-12 col-lg-4 nopa cellphone-reg-button-holder">
                                        <button type="submit" className="btn btn-block btn-solid-red button-width cursor-pointer" id="" disabled={this.state.protectiveCase == ''} onClick={this.handleSubmit}>Next</button>
                                    </div>
                                </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
        auth: state.firebase.auth,
        sales: state.sales,
        cart: state.cart,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchAction: (e) => dispatch(e),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CellphoneCase);